<template>
  <div class="Index">
    <div class="window_bg"></div>
    <div class="haerd">
      <div class="haerd_left">
        <div class="backBtn" @click.stop.prevent="goBack">返 回</div>
        <div class="title">安徽老年远程教育网</div>
      </div>
    </div>
    <div class="deer"></div>
    <div class="module_box">
      <div class="kc" @click.stop.prevent="goCourseLearning">
        <div class="text">课程学习</div>
        <img class="arrow" src="@/assets/arrow_icon.png" alt="" />
      </div>
      <div class="hd" @click.stop.prevent="goActivityParticipation">
        <div class="text">活动参与</div>
        <img class="arrow" src="@/assets/arrow_icon.png" alt="" />
      </div>
      <div class="zb" @click.stop.prevent="goLiveStreaming">
        <div class="text">直播观看</div>
        <img class="arrow" src="@/assets/arrow_icon.png" alt="" />
      </div>
      <div class="yt" @click.stop.prevent="goYuetingResources">
        <div class="text">悦听资源</div>
        <img class="arrow" src="@/assets/arrow_icon.png" alt="" />
      </div>
    </div>
    <div class="prompt">温馨提示：模拟体验，非真实操作。</div>
  </div>
</template>
<script>
export default {
  name: "index",
  data() {
    return {};
  },
  created() {},

  mounted() {},
  beforeDestroy() {},

  methods: {
    async goBack() {
      this.$router.replace({
        path: "/study/studyIndex",
      });
    },
    async goCourseLearning() {
      this.$router.push({
        path: "/study/courseLearning/index1",
      });
    },
    async goLiveStreaming() {
      this.$router.push({
        path: "/study/liveStreaming/index1",
      });
    },
    async goYuetingResources() {
      this.$router.push({
        path: "/study/yuetingResources/index1",
      });
    },
    async goActivityParticipation() {
      this.$router.push({
        path: "/study/activityParticipation/index1",
      });
    },
  },
};
</script>

<style scoped lang="less">
.newTop {
  top: 280px !important;
}
.newpadding {
  padding: 36px 40px 0 !important;
}
.newmargin {
  margin-top: 30px !important;
}
.Index {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgb(95, 141, 255) 6.107%,
    rgb(144, 181, 252) 39.695%,
    rgb(217, 240, 255) 99.237%
  );
  background-size: 100% 100%;
  border-radius: 0px;
  .window_bg {
    position: absolute;
    top: -50px;
    left: -50px;
    width: 630px;
    height: 684px;
    background: url("@/assets/colorBg/window_bg.png") no-repeat center;
    background-size: 100% 100%;
  }
}
.haerd {
  padding: 40px 30px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  .haerd_left {
    position: relative;
    z-index: 1;
    .backBtn {
      cursor: pointer;
      width: 251px;
      height: 90px;
      background: url("@/assets/colorBg/backBtn.png") no-repeat center;
      background-size: 100% 100%;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 40px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      text-shadow: 0px 1px 5px rgba(200, 121, 0, 0.5);
      border-radius: 96.5px;
      box-shadow: 0px 6px 12px 1px rgba(182, 118, 118, 0.27);
    }
    .title {
      margin-top: 40px;
      margin-left: 20px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: bold;
      font-size: 70px;
      width: 50vw;
      color: #ffffff;
      line-height: 1.2;
    }
  }
}

.deer {
  position: absolute;
  top: 130px;
  right: 80px;
  width: 282px;
  height: 300px;
  background: url("@/assets/study/studyIndex/deep.png") no-repeat center;
  background-size: 100% 100%;
}
.module_box {
  position: absolute;
  top: 430px;
  left: 50%;
  transform: translate(-50%);
  max-height: 730px;
  overflow-y: auto;
  padding: 0 10px;
  .kc {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 606px;
    height: 150px;

    box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.1);
/* 线性渐变 */
background: linear-gradient(180.00deg, rgb(255, 187, 90) 0.763%,rgb(255, 149, 35) 60.305%,rgb(255, 163, 78) 100%);
    border-radius: 15px;
    margin-bottom: 25px;
    .icon {
      width: 90px;
      height: 90px;
      // margin: 0 60px;
    }
    .text {
      width: 60%;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 50px;
      color: #ffffff;
      // margin-right: 180px;
    }
    .arrow {
      width: 25px;
      height: 45px;
    }
  }
  .hd {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 606px;
    height: 150px;

    box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.1);
/* 红色渐变 */
background: linear-gradient(180.00deg, rgb(255, 147, 147),rgb(255, 122, 111) 9.16%,rgb(255, 83, 59) 60.305%,rgb(255, 94, 94) 96.183%,rgb(255, 103, 61) 100%);
    border-radius: 15px;
    margin-bottom: 25px;
    .icon {
      width: 90px;
      height: 90px;
      // margin: 0 60px;
    }
    .text {
      width: 60%;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 50px;
      color: #ffffff;
      // margin-right: 180px;
    }
    .arrow {
      width: 25px;
      height: 45px;
    }
  }
  .zb {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 606px;
    height: 150px;

    box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.1);
/* 紫色 */
background: linear-gradient(180.00deg, rgb(193, 136, 255),rgb(173, 97, 255) 60.305%,rgb(199, 110, 254) 96.183%);
    border-radius: 15px;
    margin-bottom: 25px;
    .icon {
      width: 90px;
      height: 90px;
      // margin: 0 60px;
    }
    .text {
      width: 60%;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 50px;
      color: #ffffff;
      // margin-right: 180px;
    }
    .arrow {
      width: 25px;
      height: 45px;
    }
  }
  .yt {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 606px;
    height: 150px;

    box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.1);
/* 蓝色渐变 */
background: linear-gradient(180.00deg, rgb(123, 178, 255),rgb(51, 142, 255) 60.305%,rgb(115, 144, 255) 100%);
    border-radius: 15px;
    margin-bottom: 25px;
    .icon {
      width: 90px;
      height: 90px;
      // margin: 0 60px;
    }
    .text {
      width: 60%;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 50px;
      color: #ffffff;
      // margin-right: 180px;
    }
    .arrow {
      width: 25px;
      height: 45px;
    }
  }

}

.prompt {
  width: 100%;
  position: absolute;
  bottom: 2vh;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 30px;
  color: #666666;
  text-align: center;
}
// }
</style>
